import { LOADING } from "../../../constants/constant";
import {
  GET_TEST_DEVICES_REQUESTED,
  GET_TEST_DEVICES_SUCCESS,
  GET_TEST_DEVICES_FAILED,
  GET_TEST_DEVICES_RESET
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function getTestDevicesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEST_DEVICES_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_TEST_DEVICES_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.statusCode = action.data.status_code;
      userRes.message = action.data.message;
      userRes.data = action.data.data.data;
      userRes.isLoading = false;
      
      return userRes;

    case GET_TEST_DEVICES_FAILED:
      console.error("Error while test devices", action.error);
      return Object.assign({}, state, action.error);

      case GET_TEST_DEVICES_RESET: {
        return initialState;
      }
    default:
      return state;
  }
}
